export default __webpack_public_path__ + "static/media/logo_v1.bced344b.svg";